import { render, staticRenderFns } from "./MyRadio.vue?vue&type=template&id=0eb575c5&scoped=true&"
import script from "./MyRadio.vue?vue&type=script&lang=ts&"
export * from "./MyRadio.vue?vue&type=script&lang=ts&"
import style0 from "./MyRadio.vue?vue&type=style&index=0&id=0eb575c5&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb575c5",
  null
  
)

export default component.exports